import type { AuthSession } from '@leoclinic/types';

/**
 * Sessão mock para desenvolvimento/demo sem Supabase.
 * Dados genéricos — cada instalação configura a sua clínica em Definições.
 */
export const MOCK_SESSION: AuthSession = {
  user: {
    id: 'demo-user-id',
    clinic_id: 'demo-clinic-id',
    email: 'admin@leoclinic.local',
    full_name: 'Administrador',
    avatar_url: null,
    phone: null,
    role: 'administrator',
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    created_by: null,
  },
  clinic: {
    id: 'demo-clinic-id',
    name: 'Minha Clínica',
    slug: 'demo-clinica',
    email: 'contacto@clinica.pt',
    phone: null,
    address: 'Morada a definir',
    city: 'Cidade',
    postal_code: '0000-000',
    country: 'PT',
    logo_url: null,
    timezone: 'Europe/Lisbon',
    currency: 'EUR',
    status: 'active',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    created_by: null,
  },
};
